// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Sites\Enums\SiteProjectionField
// Generated on: <normalized>

export enum SiteProjectionField {
  TECHNICAL_URL = 'technicalURL',
  WEB_URL = 'webURL',
  VESTA_INSPECTION = 'vestaInspection',
  INSPECTION_STATUS = 'status',
  CHECKED_AT = 'checkedAt',
  DIFFERENCES = 'differences',
}

export const SiteProjectionFieldCases = ["technicalURL", "webURL", "vestaInspection", "status", "checkedAt", "differences"] as const;
